import cn from "classnames";

import Info from "assets/icons/info.svg?react";

import { Popover } from "shared/ui/components/Popover";
import { Typography } from "shared/ui/components/Typography";

import styles from "./InvestmentGraphic.module.scss";

const InvestmentGraphic = ({
  className,
  bigGraphic = false,
  infoPopover,
  innerClassName,
  positive = false,
  children,
  title,
  price,
  description,
}: {
  className?: string;
  askAvatar?: boolean;
  bigGraphic?: boolean;
  infoPopover?: React.ReactNode;
  innerClassName?: string;
  positive?: boolean;
  children?: React.ReactNode;
  title?: string;
  price?: string;
  description?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(styles.root, { [styles.rootBig]: bigGraphic }, className)}
    >
      <div className={styles.header}>
        {!!infoPopover && (
          <Popover
            placement="top"
            triggerType="hover"
            yOffset={15}
            floatingArrowProps={{ width: 17, height: 10, fill: "#fff" }}
            triggerClassName={styles.trigger}
            triggerElement={() => <Info className={styles.button} />}
          >
            {infoPopover}
          </Popover>
        )}
        {title && (
          <Typography
            className={styles.title}
            variant="bodyS"
            weight="semiBold"
          >
            {title}
          </Typography>
        )}
      </div>
      <div className={cn(styles.content, { [styles.contentBig]: bigGraphic })}>
        {price && (
          <Typography
            className={cn(styles.price, { [styles.pricePositive]: positive })}
            variant="h5"
            weight="semiBold"
          >
            {price}
          </Typography>
        )}
        <div className={styles.description}>{description}</div>
      </div>
      <div
        className={cn(
          styles.inner,
          { [styles.innerBig]: bigGraphic },
          innerClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default InvestmentGraphic;
